module.exports = __webpack_public_path__ + "media/assets/omniauth-clever-logo-141bc579903e1231f370cee8c3854dce.svg";